import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import Furni from "../assets/img/Furni5.png";
import Shoes from "../assets/img/shoes2.png";
import Sports from "../assets/img/sports_week.png";
import Car from "../assets/img/car_web.png";
import Cancer_detect from "../assets/img/c1.jpeg";
import Skin_Cancer from "../assets/img/skin_cancer_3.png";

import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

   const projects = [
    {
      title: "Furniture Website",
      description: "Design & Development",
      imgUrl: Furni,
      githubUrl: "https://github.com/Wahaj1224/Furniture_website",
    },
    {
      title: "Shoes Ecommerce Website",
      description: "Design & Development",
      imgUrl: Shoes,
      githubUrl: "https://github.com/Wahaj1224/React_Shoes_website",
    },
    {
      title: "Breast Cancer Detection",
      description: "Ai & Machine Learning",
      imgUrl: Cancer_detect,
      githubUrl: "https://github.com/Wahaj1224/Breast_Cancer_Detection-Using-Neral-Networks",
    },
    {
      title: "Skin Cancer Detection ",
      description: "Ai & Machine Learning",
      imgUrl: Skin_Cancer,
      githubUrl: "https://github.com/Wahaj1224/Skin_Cancer_Detection-Using-Yolo11-accuracy-89.8_Percent",
    },
    {
      title: "Event Management",
      description: "UI/UX",
      imgUrl: Sports,
      githubUrl: "https://www.behance.net/gallery/229608591/Sports_Week_Website(design)",
    },
    {
      title: "Carvilla Website ",
      description: "UI/UX",
      imgUrl: Car,
      githubUrl: "https://www.behance.net/gallery/229609245/Car_website_UIUX",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>A showcase of my work in web development , app development , AI/ML , UI/UX , and backend engineering. These projects highlight my skills as a software engineer, building responsive websites, mobile apps, and intelligent systems with clean, secure, and scalable code.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <div style={{ marginTop: '130px' }}>
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                             
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                           
                            )
                          })
                        }
                      </Row>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">

                      <p>No More Projects to Show</p>

                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>No More Projects to Show</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
